import {Instance, types, getParentOfType} from "mobx-state-tree";
import {nanoid} from "nanoid";
import {QuizQuestionModel, QuizQuestionModelType} from "./QuizQuestionModel";


export type QuizQuestionOptionModelType = Instance<typeof QuizQuestionOptionModel>;


export const QuizQuestionOptionModel = types.model("QuizQuestionOption")
    .props({
        id: types.optional(types.identifier, () => nanoid()),
        text: types.optional(types.string, ''),
        isCorrect: types.optional(types.boolean, false),
        hint: types.optional(types.maybeNull(types.string), null),
    })
    .views(self => ({
        get quizQuestion(): any {
            return getParentOfType(self, QuizQuestionModel)
        }
    }))
    .actions(self => ({
        setText(text: string) {
            self.text = text;
            self.quizQuestion.setHasChange(true);
        },
        setIsCorrect(isCorrect: boolean) {
            self.isCorrect = isCorrect;
            self.quizQuestion.setHasChange(true);
        },
    }))
